<template>
  <VRow class="align-center add-to-cart-row" no-gutters>
    <VCol v-if="value === 0" cols="12">
      <SBtn
        block
        variant="outlined"
        class="py-2 font14 text-initial add-to-cart-button"
        height="28"
        rounded
        data-testid="add-product-to-cart"
        :disabled="loading"
        @click="addToCart(1)"
      >
        {{ text }}
      </SBtn>
    </VCol>
    <VCol v-else cols="12">
      <div class="qty-controls" translate="no">
        <SBtn
          icon
          small
          class="qty-circle"
          :disabled="loading"
          aria-label="Decrease quantity"
          @click="decrement"
        >
          <VIcon size="18" color="primary">
            {{ icons.mdiMinus }}
          </VIcon>
        </SBtn>
        <span class="font16 font-weight-medium" translate="no">{{ value }}</span>
        <SBtn
          icon
          small
          class="qty-circle"
          :disabled="incrementDisabled || loading"
          aria-label="Increase quantity"
          @click="increment"
        >
          <VIcon size="18" color="primary">
            {{ icons.mdiPlus }}
          </VIcon>
        </SBtn>
      </div>
    </VCol>
  </VRow>
</template>

<script lang="ts" setup>
import { mdiPlus, mdiMinus } from '@mdi/js'
import { useItemQty} from "~/composables/useItemQty"
import type { ItemQtyEmitFn } from "~/composables/useItemQty"

const props = withDefaults(defineProps<{
  text?: string
  maxValue?: number
  loading?: boolean
  initialQuantity?: number
  incrementDisabled?: boolean
}>(), {
  text: undefined,
  maxValue: 99,
  loading: false,
  initialQuantity: 1,
  incrementDisabled: false
})
const emits = defineEmits<ItemQtyEmitFn>()

const icons = { mdiPlus, mdiMinus }

const {
  addToCart,
  decrement,
  increment,
  incrementDisabled,
  value
} = useItemQty(props, emits)
</script>

<style scoped lang="scss">
.add-to-cart-row {
  width: 100%;
}

.add-to-cart-button {
  letter-spacing: 1.25px;
  max-width: none;
}

.qty-controls {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
  height: 28px;
  border: 1px solid rgb(var(--v-theme-primary));
  border-radius: 6px;
}

.qty-circle {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid rgb(var(--v-theme-border));
  background: white;
  cursor: pointer;
}
</style>
